export const validatePhotoSize = (value: any, context: any) => {
  return !(!value || context.parent.file.size > 5000000);
};
